/* these represent the indexes of the gear array in settings and encounter results */
/* some slots (relic, ranged, quiver) might be empty depending on class and phase */
enum GearSlot {
  Head,
  Hands,
  Neck,
  Waist,
  Shoulder,
  Legs,
  Back,
  Feet,
  Chest,
  Wrist,
  Finger,
  Finger2,
  Mainhand,
  Offhand,
  Trinket,
  Trinket2,
  Relic,
  Ranged,
  Quiver
}

export default GearSlot
